module.exports = __webpack_public_path__ + "static/ally-icon.036281fadcb78861777fac63a39d8eaf.png";